<style scoped lang="less" scoped>
.echart-main {
  width: 100%;
  height: 400px;
}
.lens {
  width: 320px;
  margin: 0 auto;
  li {
    float: left;
    margin: 0 10px;
    span {
      padding: 0px 10px;
      border-radius: 4px;
      background-color: cornflowerblue;
      margin-right: 5px;
    }
  }
}
</style>
<template>
  <div>
    <div class="page-content">
      <div class="title">
        <el-row>
          <el-col :span="12">查询结果</el-col>
          <el-col :span="12" class="text-right">
            <el-button type="primary" plain size="small" @click="downBtn">下载</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="content">
        <!-- <div class="lens">
          <ul>
            <li>
              <span style="background-color:#ccc"></span>≤0
            </li>
            <li>
              <span style="background-color:#f50705"></span>0-50
            </li>
            <li>
              <span style="background-color:#fdfe02"></span>>50-95
            </li>
            <li>
              <span style="background-color:#36b494"></span>>95
            </li>
          </ul>
        </div>-->
        <div :id="echartId" class="echart-main"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "calendarEchartsOption",
  props: {
    title: String,
    optionData: Object,
    echartId: {
      type: String,
      required: true,
    },
    downCsvBtn: Function,
  },
  data() {
    return {
      titleTime: "1小时",
      newEchart: "",
      option: {
        tooltip: {
          formatter: function (params) {
            let html = `
                <div class="tooltip-box">
                ${params.value}
                </div>
            `;
            return html;
          },
        },
        visualMap: {
          type: "piecewise",
          splitNumber: 4,
          orient: "horizontal",
          min: 0,
          max: 100,
          top: 0,
          left: "center",
          pieces: [
            {
              min: 95,
            },
            {
              min: 50,
              max: 95,
            },
            {
              min: 0,
              max: 50,
            },
            {
              lte: 0,
            },
          ],
          color: ["#36b494", "#fdfe02", "#f50705", "#ccc"],
        },

        calendar: [
          {
            left: "5%",
            top: "25%",
            right: "3%",
            bottom: "10%",
            range: [],
            splitLine: {
              show: true,
              lineStyle: {
                color: "#016692",
                width: 1,
                type: "solid",
              },
            },
            yearLabel: {
              formatter: "2019年",
            },
            monthLabel: {
              formatter: "{M}月",
              color: "#000",
            },
            dayLabel: {
              nameMap: "cn",
              color: "#000",
            },
            itemStyle: {
              color: "red",
              normal: {
                color: "#ccc",
                borderWidth: 1,
                borderColor: "#fff",
              },
            },
          },
        ],
        series: [
          {
            //   name: "",
            type: "heatmap",
            coordinateSystem: "calendar",
            data: [],
            calendarIndex: 0,
            label: {
              normal: {
                show: true,
                formatter: (params) => {
                  var d = this.$Echarts.number.parseDate(params.value[0]);
                  return d.getDate();
                },
                textStyle: {
                  color: "#fff",
                },
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    // getVirtulData(year) {
    //   year = year || "2017";
    //   var date = +this.$Echarts.number.parseDate(year + "-01-01");
    //   var end = +this.$Echarts.number.parseDate(year + "-12-31");
    //   var dayTime = 3600 * 24 * 1000;
    //   var data = [];
    //   for (var time = date; time <= end; time += dayTime) {
    //     data.push([
    //       this.$Echarts.format.formatTime("yyyy-MM-dd", time),
    //       Math.floor(Math.random() * 10000)
    //     ]);
    //   }
    //   //   console.log("data", data);
    //   return data;
    // },
    newEcharts() {
      // console.log('echartId',echartId)
      //   this.option.yAxis.name = this.optionData.title + this.optionData.unit; //单位
      this.option.calendar[0].range = this.optionData.time; //y轴数据
      this.option.calendar[0].yearLabel.formatter =
        this.optionData.time[0] + "~" + this.optionData.time[1];
      this.option.series[0].data = this.optionData.data; //y轴数据
      this.option.series[0].name = this.optionData.title; //展示数据title
      setTimeout(() => {
        this.newEchart = this.$Echarts.init(
          document.getElementById(this.echartId)
        );
        this.newEchart.on("click", (params) => {
          // console.log("dat", params);
          if (params.data[1] !== 100) {
            this.$confirm("是否补传的" + params.data[0] + "数据?", "数据补传", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.updateData(this.optionData.deviceId, params.data[0]);
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消上传",
                });
              });
          }
        });
        this.newEchart.setOption(this.option);
      }, 1000);
    },
    updateData(id, date) {
      this.$$http("echartsAchieveUpdate", {
        target_id: id,
        date: date,
      })
        .then((results) => {
          console.log("日期", results);
          if (results.data && results.status == 201) {
            this.$emit("achieveDataUpdate", true);
            this.$message({
              type: "success",
              message: "补传成功!",
            });
          }
        })
        .catch((err) => {});
    },
    downBtn() {
      this.$emit("downCsvBtn", true);
    },
  },
  mounted() {
    this.newEcharts();
  },
  watch: {
    optionData: {
      handler(newName, oldName) {
        console.log("newName", newName);
        this.newEcharts();
      },
      deep: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/calendarEchartsOption.vue